var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97462 10L0.624622 2.65C0.374622 2.4 0.253789 2.10417 0.262122 1.7625C0.270455 1.42083 0.399622 1.125 0.649622 0.875C0.899622 0.625 1.19546 0.5 1.53712 0.5C1.87879 0.5 2.17462 0.625 2.42462 0.875L10.0996 8.575C10.2996 8.775 10.4496 9 10.5496 9.25C10.6496 9.5 10.6996 9.75 10.6996 10C10.6996 10.25 10.6496 10.5 10.5496 10.75C10.4496 11 10.2996 11.225 10.0996 11.425L2.39962 19.125C2.14962 19.375 1.85796 19.4958 1.52462 19.4875C1.19129 19.4792 0.899622 19.35 0.649622 19.1C0.399622 18.85 0.274622 18.5542 0.274622 18.2125C0.274622 17.8708 0.399622 17.575 0.649622 17.325L7.97462 10Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.cc6f99ce785eaa7a52943d72a3ca3342.svg";
export { ForwardRef as ReactComponent };